import type { useQueryClient } from '@tanstack/react-query';

import { learningOpportunityKeys } from './query-keys';

export const invalidateLearningOpportunityCaches = (queryClient: ReturnType<typeof useQueryClient>): void => {
    queryClient.invalidateQueries({ queryKey: learningOpportunityKeys.details() });
    queryClient.invalidateQueries({ queryKey: learningOpportunityKeys.filter() });
    queryClient.invalidateQueries({ queryKey: learningOpportunityKeys.allStatistics() });
};
